// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3kz7E","additionalInfo":"AgreementModal_additionalInfo__2m9XN"};